import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import {
	calcPerpetualRentMonthly,
	calcRentToZeroMonthly,
} from "web_myplann/Goals/Helpers/rentCalculation";
import {
	GoalCategoryTypeEnum,
	type GoalDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const mapGoalDtoToForm = (
	dto: GoalDetailResponseDTO,
): Partial<GoalFormModel> => {
	const isRentBased =
		dto.investmentPlanCategoryType === GoalCategoryTypeEnum.Pension ||
		dto.investmentPlanCategoryType === GoalCategoryTypeEnum.Rent;
	const hasRentYears = (dto.rentYears ?? 0) > 0;
	const drawdownMode = isRentBased
		? hasRentYears
			? "to-zero"
			: "perpetual"
		: undefined;

	const totalValue = dto.oneTimePayment ?? dto.targetAmount ?? undefined;

	const monthlyRent = (() => {
		if (!isRentBased) return undefined;
		if ((dto.monthlyRent ?? 0) > 0) return dto.monthlyRent ?? undefined;
		if (totalValue == null) return undefined;
		return drawdownMode === "perpetual"
			? calcPerpetualRentMonthly(totalValue) || undefined
			: calcRentToZeroMonthly(totalValue, dto.rentYears ?? 0) || undefined;
	})();

	return {
		category: dto.investmentPlanCategoryType,
		name: dto.name ?? "",
		dueDate: dto.targetDate ? new Date(dto.targetDate) : undefined,
		totalValue,
		ownFunds: dto.ownFunds ?? 0,
		loanAmount: dto.loanAmount ?? 0,
		monthlyRent,
		rentYears: dto.rentYears ?? undefined,
		drawdownMode,
	};
};
